"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let InvoicesFilters = class InvoicesFilters extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
        this.$$cache_item = new core_1.ComponentValueCache(this, "item", "InvoicesFilters");
    }
    item;
    async $$load_item() {
        return {
            date_from: null,
            date_to: null,
            unpaid: false,
            kind: this.kind,
            date_type: "invoice_date",
        };
    }
    ux;
    b_2248226175642056_options;
    dataMembers = ['item', 'ux', 'b_2248226175642056_options'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                item: null,
                ux: null,
                b_2248226175642056_options: [{
                        value: "invoice_date",
                        text: this.$fn.pgettext("Invoice", "Invoice date"),
                    },
                    {
                        value: "fulfillment_date",
                        text: this.$fn.pgettext("Invoice", "Fulfillment date"),
                    },
                    {
                        value: "due_date",
                        text: this.$fn.pgettext("Invoice", "Due date"),
                    },
                ],
            },
        };
    }
    async act_5962862420439144_setData_7686_getActionArgs($event) {
        return {
            path: "item.date_from",
            value: $event.data[0],
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async act_5962862420439144_setData_7688_getActionArgs($event) {
        return {
            path: "item.date_to",
            value: $event.data[1],
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_5962862420439144_changed(event, scope) {
        return await this.actions.evh_5962862420439144_changed.executeFromDOM(this, event, scope);
    }
    async act_1048678296148443_emit_7690_getActionArgs($event) {
        return {
            event: "submit",
            value: { ...this.item, kind: this.kind },
        };
    }
    async evh_1048678296148443_clickPreventStop(event, scope) {
        return await this.actions.evh_1048678296148443_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_5962862420439144_setData_7686 = new core_1.actions.SetDataAction({
            actionArgs: this.act_5962862420439144_setData_7686_getActionArgs,
            events: [],
        });
        const evh_5962862420439144_changed_7685 = new core_1.actions.EventHandlerImpl({
            action: act_5962862420439144_setData_7686,
            event: "changed",
            displayName: "setData",
        });
        const act_5962862420439144_setData_7688 = new core_1.actions.SetDataAction({
            actionArgs: this.act_5962862420439144_setData_7688_getActionArgs,
            events: [],
        });
        const evh_5962862420439144_changed_7687 = new core_1.actions.EventHandlerImpl({
            action: act_5962862420439144_setData_7688,
            event: "changed",
            displayName: "setData",
        });
        const evh_5962862420439144_changed = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5962862420439144_changed_7685, evh_5962862420439144_changed_7687],
        });
        const act_1048678296148443_emit_7690 = new core_1.actions.EmitAction({
            actionArgs: this.act_1048678296148443_emit_7690_getActionArgs,
            events: [],
        });
        const evh_1048678296148443_clickPreventStop_7689 = new core_1.actions.EventHandlerImpl({
            action: act_1048678296148443_emit_7690,
            event: "click.prevent.stop",
            displayName: "emit",
        });
        const evh_1048678296148443_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1048678296148443_clickPreventStop_7689],
        });
        return {
            act_5962862420439144_setData_7686,
            evh_5962862420439144_changed_7685,
            act_5962862420439144_setData_7688,
            evh_5962862420439144_changed_7687,
            evh_5962862420439144_changed,
            act_1048678296148443_emit_7690,
            evh_1048678296148443_clickPreventStop_7689,
            evh_1048678296148443_clickPreventStop,
        };
    }
};
InvoicesFilters = __decorate([
    (0, vue_property_decorator_1.Component)()
], InvoicesFilters);
exports.default = InvoicesFilters;
vue_property_decorator_1.Vue.component("InvoicesFilters", InvoicesFilters);
